import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {choose} from 'lit/directives/choose.js';
import store from '../../store';

@customElement('shared-specsheet')
export class SharedSpecsheet extends connect(store)(LitElement) {

	static styles = [
		css`
		`
	];

	@property({type: String})
	type = 'detail'; // family, basic, detail

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
	}

	connectedCallback() {
		super.connectedCallback();
	}

	render() {
		return html`

			${choose(this.status.family, [
					[
						'LightProfile',
						() => html`
							<light-new-specsheet type="${this.type}"></light-new-specsheet>`
					],
					[
						'Line',
						() => html`
							<line-specsheet type="${this.type}"></line-specsheet>`
					],
					[
						'Aeto',
						() => html`
							<solar-specsheet type="${this.type}"></solar-specsheet>`
					],
					[
						'Olivio',
						() => html`
							<olivio-specsheet type="${this.type}"></olivio-specsheet>`
					],
				],
				() => html`
					<new-specsheet type="${this.type}"></new-specsheet>`
			)}

		`;
	}
}
